/** rrweb never records matching subtrees (password, token, secret fields). */
export const REPLAY_BLOCK_SELECTOR = [
  "[data-replay-block]",
  'input[type="password"]',
  'input[autocomplete*="password" i]',
  'input[name*="password" i]',
  'input[name*="secret" i]',
  'input[name*="token" i]',
  "#tax-sign-in-password",
  ".copyable__value",
  "canvas",
].join(",");

/** rrweb masks text content inside matching nodes. */
export const REPLAY_MASK_SELECTOR = "[data-replay-mask]";
